import styled, { css } from 'styled-components';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import GridItem from '../GridItem';
import { mediaQueries } from '../../utils/mediaQueries';
import { NEXT_COMPONENT_SPACING } from '../../config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const sharedColumnStyles = css(["border-color:", ";border-style:solid;"], TABLE_BORDER_COLOR);
const LeftColumn = styled(GridItem).withConfig({
  displayName: "LeftColumnComp__LeftColumn",
  componentId: "inqcag-0"
})(["", " padding:0 13px 0 0;", "{&&{max-width:100%;padding:0;}}border-width:0 0 0 0;max-width:50%;h4{margin-top:0;margin-bottom:", "px;}"], sharedColumnStyles, mediaQueries.belowLaptop, NEXT_COMPONENT_SPACING);
const LeftColumnComp = ({
  children,
  columnSpan
}) => {
  return /*#__PURE__*/_jsx(LeftColumn, {
    columns: columnSpan,
    className: "left-column",
    children: children
  });
};
export default LeftColumnComp;